import Vue from 'vue'

export default {
  namespaced: true,
  state: {
    answers: {},
    currentStepIdx: 0,
    steps: []
  },
  getters: {
    getAnswer: (state) => (answerId) => state.answers[answerId],
    getAnswerValues: (state) => Object.values(state.answers),
    getAnswers: (state) => state.answers,
    getCurrentStepIdx: (state) => state.currentStepIdx,
    getSteps: (state) => state.steps
  },
  mutations: {
    SET_ANSWER(state, answer) {
      Vue.set(state.answers, answer.id, answer)
    },
    SET_ANSWERS(state, answers) {
      state.answers = answers
    },
    CLEAR_ANSWERS(state) {
      state.answers = {}
    },
    SET_CURRENT_STEP_IDX(state, idx) {
      state.currentStepIdx = idx
    },
    SET_STEPS(state, steps) {
      state.steps = steps
    },
    RESET_SURVEY(state) {
      state.answers = {}
      state.currentStepIdx = 0
      state.steps = []
    }
  },
  actions: {
    saveAnswer({ commit }, answer) {
      commit('SET_ANSWER', answer)
    },
    setAnswers({ commit }, answers) {
      commit('SET_ANSWERS', answers)
    },
    clearAnswers({ commit }) {
      commit('CLEAR_ANSWERS')
    },
    setCurrentStepIdx({ commit }, idx) {
      commit('SET_CURRENT_STEP_IDX', idx)
    },
    setSteps({ commit }, steps) {
      commit('SET_STEPS', steps)
    },
    resetSurvey({ commit }) {
      commit('RESET_SURVEY')
    }
  }
}
